<app-menu></app-menu>
<div class="profile-container">
  <div class="profile">
    <div class="profile-img">
      <fa-icon [icon]="faUserAlt"></fa-icon>
    </div>
    <div class="info">
      <p>Nome: {{ nombre }}</p>
      <p>CRM: {{ dni }}</p>
      <!-- <p>Celular: {{ celular }}</p> -->
      <!-- <p>Edad: {{ edad }}</p> -->
      <p>Email: {{ email }}</p>
    </div>
    <!-- <button class="button">Modificar datos</button> -->
    <button class="button">Fechar Sessão</button>
  </div>
  <div class="dates">
    <div class="programadas">
      <h5>Compromissos Agendados</h5>
      <div class="list">
        <div *ngFor="let cita of userDates; let indice = index">
          <app-date [especialidad]="cita.especialidad" [nombreDoctor]="cita.nombreDoctor" [hora]="cita.hora"
            [fecha]="fecha[indice]" [finalizada]="cita.time" id="{{cita._id}}" [id]="cita._id" (click)="getDate(cita._id)"></app-date>
        </div>
      </div>
    </div>
    <div class="recientes">
      <h5>Citações Recentes</h5>
      <div class="list">
        <div *ngFor="let cita of datesFin">
            <app-date [especialidad]="cita.especialidad" [nombreDoctor]="cita.nombreDoctor" [hora]="cita.hora" [fecha]="cita.fecha" [finalizada]="cita.finalizada" id="{{cita._id}}" [id]="cita._id" (click)="getDate(cita._id)"></app-date>
          </div>
      </div>
    </div>
  </div>
</div>